var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProParticipants(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49917 0.1875C4.50197 0.1875 3.69155 1.00804 3.69322 2.02146C3.69322 3.03487 4.50197 3.85542 5.49917 3.85542C6.49636 3.85542 7.30678 3.03487 7.30678 2.02146C7.30678 1.00804 6.49803 0.1875 5.49917 0.1875ZM5.49917 4.34436C5.23736 4.34605 4.94888 4.32237 4.62371 4.26146C3.98003 4.13965 3.59316 3.7979 2.81275 3.95354C1.09518 4.29699 -0.378929 9.30485 1.72385 9.37421C2.84944 9.41143 3.5348 8.11717 4.38525 7.77711C4.6137 7.68575 5.06727 7.64176 5.49917 7.64007C5.93273 7.64176 6.38463 7.68575 6.61475 7.77711C7.4652 8.11717 8.15056 9.41143 9.27615 9.37421C11.3789 9.30485 9.90482 4.29699 8.18725 3.95354C7.40684 3.7962 7.0183 4.13796 6.3763 4.26146C6.05112 4.32237 5.76264 4.34605 5.49917 4.34436Z",
    fill: "#2A9BCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProParticipants);
export default __webpack_public_path__ + "static/media/icon-pro-participants.c4398d1318f81d1913389a4a0a8385fef43f6b24d6cf2d195e09239e2ee0a641.svg";
export { ForwardRef as ReactComponent };